import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { uploadLoanApplication } from "../../services/GetFinanceService";
import { ToastContainer, toast } from "react-toastify";

const GetFinance = () => {
  const [loanApplication, setLoanApplication] = useState({
    applyingAs: "Individual",
    name: "",
    companyName: "",
    email: "",
    phone: "",
    address: "",
    pincode: "",
    city: "",
    state: "",
    employmentStatus: "Salaried",
    droneModel: "",
    loanAmount: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoanApplication((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setLoanApplication((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const requiredFields = [
      "applyingAs",
      "name",
      "email",
      "phone",
      "address",
      "pincode",
      "city",
      "state",
      "employmentStatus",
      "droneModel",
      "loanAmount",
    ];

    for (const field of requiredFields) {
      if (!loanApplication[field]) {
        toast.error(`Please fill in the ${field}.`);
        return false;
      }
    }

    if (
      loanApplication.applyingAs === "Company" &&
      !loanApplication.companyName
    ) {
      toast.error("Please fill in the Company Name.");
      return false;
    }

    if (!validateEmail(loanApplication.email)) {
      toast.error("Invalid email format.");
      return false;
    }

    return true;
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const sendData = async () => {
    if (validateForm()) {
      // Call validateForm() to execute the validation logic
      const response = await uploadLoanApplication(loanApplication);
      if (response?.status === "success") {
        setLoanApplication({
          applyingAs: "Individual",
          name: "",
          companyName: "",
          email: "",
          phone: "",
          address: "",
          pincode: "",
          city: "",
          state: "",
          employmentStatus: "Salaried",
          droneModel: "",
          loanAmount: "",
        });
        toast.success("Application submitted successfully");
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="bg_clr_light_green py-5">
        <Container>
          <div className="bg-white p-lg-5 p-4 rounded-2">
            <div>
              <h2 className="mb-0 ff_heebo fw-bold fs_6xl_2">
                Get <span className="clr_dark_green">Finance</span>
              </h2>
            </div>

            <div className="mt-5">
              <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
                Applying for loan as
              </h4>
              <div className="d-flex align-items-center gap-4 mt-2">
                <div className="d-flex align-items-center gap-2 cursor_pointer">
                  <input
                    className="clr_dark_grey_4 mt-1 cursor_pointer"
                    type="radio"
                    name="applyingAs"
                    value="Individual"
                    checked={loanApplication.applyingAs === "Individual"}
                    onChange={handleRadioChange}
                  />
                  <label className="cursor_pointer">Individual</label>
                </div>
                <div className="d-flex align-items-center gap-2 cursor_pointer">
                  <input
                    className="clr_dark_grey_4 mt-1 cursor_pointer"
                    type="radio"
                    name="applyingAs"
                    value="Company"
                    checked={loanApplication.applyingAs === "Company"}
                    onChange={handleRadioChange}
                  />
                  <label className="cursor_pointer">Company</label>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
                Contact Information
              </h4>
              <div>
                <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
                  <input
                    className={`${
                      loanApplication.applyingAs === "Company"
                        ? "finance-inputs"
                        : "finance-inputs-2"
                    } px-3 clr_dark_grey_4 w-100`}
                    type="text"
                    placeholder="Name *"
                    name="name"
                    value={loanApplication.name}
                    onChange={handleChange}
                  />
                  {loanApplication.applyingAs === "Company" && (
                    <input
                      className="finance-inputs px-3 clr_dark_grey_4 w-100"
                      type="text"
                      placeholder="Company Name *"
                      name="companyName"
                      value={loanApplication.companyName}
                      onChange={handleChange}
                    />
                  )}
                </div>
                <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
                  <input
                    className="finance-inputs px-3 clr_dark_grey_4 w-100"
                    type="number"
                    placeholder="Phone Number *"
                    name="phone"
                    value={loanApplication.phone}
                    onChange={handleChange}
                  />
                  <input
                    className="finance-inputs px-3 clr_dark_grey_4 w-100"
                    type="text"
                    placeholder="Email Address *"
                    name="email"
                    value={loanApplication.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <input
              className="finance-inputs-2 px-3 clr_dark_grey_4 w-100 mt-3"
              type="text"
              placeholder="Address *"
              name="address"
              value={loanApplication.address}
              onChange={handleChange}
            />
            <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
              <input
                className="finance-inputs px-3 clr_dark_grey_4 w-100"
                type="number"
                placeholder="Pin Code *"
                name="pincode"
                value={loanApplication.pincode}
                onChange={handleChange}
              />
              <input
                className="finance-inputs px-3 clr_dark_grey_4 w-100"
                type="text"
                placeholder="City *"
                name="city"
                value={loanApplication.city}
                onChange={handleChange}
              />
            </div>
            <input
              className="finance-inputs px-3 clr_dark_grey_4 w-100 mt-4"
              type="text"
              placeholder="State *"
              name="state"
              value={loanApplication.state}
              onChange={handleChange}
            />

            <div className="mt-5">
              <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
                Employment Status
              </h4>
              <div className="d-flex align-items-sm-center gap-sm-4 gap-2 mt-2 flex-column flex-sm-row">
                <div className="d-flex align-items-center gap-2 cursor_pointer">
                  <input
                    className="clr_dark_grey_4 mt-1 cursor_pointer"
                    type="radio"
                    name="employmentStatus"
                    value="Salaried"
                    checked={loanApplication.employmentStatus === "Salaried"}
                    onChange={handleRadioChange}
                  />
                  <label className="cursor_pointer">Salaried</label>
                </div>
                <div className="d-flex align-items-center gap-2 cursor_pointer">
                  <input
                    className="clr_dark_grey_4 mt-1 cursor_pointer"
                    type="radio"
                    name="employmentStatus"
                    value="Self Employed"
                    checked={
                      loanApplication.employmentStatus === "Self Employed"
                    }
                    onChange={handleRadioChange}
                  />
                  <label className="cursor_pointer">Self Employed</label>
                </div>
                <div className="d-flex align-items-center gap-2 cursor_pointer">
                  <input
                    className="clr_dark_grey_4 mt-1 cursor_pointer"
                    type="radio"
                    name="employmentStatus"
                    value="Business"
                    checked={loanApplication.employmentStatus === "Business"}
                    onChange={handleRadioChange}
                  />
                  <label className="cursor_pointer">Business</label>
                </div>
              </div>
            </div>
            <div className="d-flex flex-sm-row flex-column align-items-center justify-content-between mt-4 gap-4">
              <div className="w-100">
                <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
                  Drone Model
                </h4>
                <input
                  className="finance-inputs px-3 clr_dark_grey_4 w-100 mt-3"
                  type="text"
                  placeholder="Drone Model *"
                  name="droneModel"
                  value={loanApplication.droneModel}
                  onChange={handleChange}
                />
              </div>
              <div className="w-100">
                <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
                  Loan Amount
                </h4>
                <input
                  className="finance-inputs px-3 clr_dark_grey_4 w-100 mt-3"
                  type="number"
                  placeholder="Loan Amount *"
                  name="loanAmount"
                  value={loanApplication.loanAmount}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="mt-4">
              <button
                style={{ width: "260px", height: "40px" }}
                className="common-darkgreen-button mt-4 text-uppercase mx-auto px-4 ff_heebo fw-medium text-white text-uppercase rounded-3 fs_xxsm"
                onClick={sendData}
              >
                Submit Application
              </button>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default GetFinance;
